// extracted by mini-css-extract-plugin
export default {"mobile":"460px","tablet":"768px","desktop":"1024px","header":"1130px","smLaptop":"1280px","laptop":"1360px","Menu":"RRWKW","Menu__wrapper":"E2Y5U","Menu__content":"IiAs5"};